__turbopack_context__.v({
  "root": "LabelledSelect-module__7o_s5G__root" + " " + __turbopack_context__.i(60951)["labelledStyles"],
});
